<template>
  <div>
    <h2 class="main-heading">{{ this.sliderData.Title }}</h2>
    <div class="routine-slider__innerContainer">
      <div class="slider-block component relatedarticle">
        <div class="slider-block__content">
          <div class="slider --controls-top --cards card-list" v-slider>
            <button
              type="button"
              class="slider-control slider-control__prev"
              data-slider-control="prev"
            >
              <svg role="img" class="icon" aria-label="Previous">
                <use
                  xlink:href="#arrow-left"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                ></use>
              </svg>
            </button>
            <div class="slider__list nosubtitle" data-slider-list>
              <div
                class="slider__item routine-card__item"
                data-slider-slide
                v-for="(item, index) in sliderData.Cards"
                :key="index"
              >
                <div class="routine-card__imageContainer">
                  <img
                    v-if="item.CardImage?.Src"
                    class="lazy routine-card__imageTag"
                    :class="{ blurImgEnable: openproductPopin === index }"
                    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                    :data-src="item.CardImage.Src ? item.CardImage.Src : ''"
                    :alt="item.CardImage.Alt ? item.CardImage.Alt : ''"
                  />
                  <button
                    class="routine-card__imageCta"
                    @click="openPopinCta(item, index)"
                  >
                    {{ sliderData?.CTALabel }}
                    <span>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M15.7454 14.2032L16.9939 12.8918L10.6348 6.21226C10.286 5.84591 9.71389 5.84591 9.36511 6.21226L3.00598 12.8918L4.25448 14.2032L9.99996 8.16824L15.7454 14.2032Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </button>

                  <div
                    :class="{ animated: openproductPopin === index }"
                    class="routine-card-popin__listProduct"
                  >
                    <div
                      @click="closePopinCta"
                      role="button"
                      class="routine-card-popin__close"
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M23.071 8.92871L8.92891 23.0708"
                          stroke="white"
                          stroke-width="3"
                        />
                        <path
                          d="M23.071 23.0713L8.92891 8.92915"
                          stroke="white"
                          stroke-width="3"
                        />
                      </svg>
                    </div>
                    <div
                      class="routine-card-popin__listall"
                      v-for="list in item.Routines"
                    >
                      <div class="routine-card-popin__productImg">
                        <img
                          class="lazy"
                          v-if="list.RoutineProductImage?.Src"
                          src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                          :data-src="
                            list.RoutineProductImage?.Src
                              ? list.RoutineProductImage.Src
                              : ''
                          "
                          :alt="
                            list.RoutineProductImage?.Alt
                              ? list.RoutineProductImage.Alt
                              : ''
                          "
                        />
                      </div>
                      <div class="routine-card-popin__productDetails">
                        <div
                          v-if="list.RoutineLabel"
                          class="routine-card-popin__productSteps"
                          v-titleSup="list.RoutineLabel"
                        > 
                        </div>
                        <h3
                          v-if="list.RoutineProductTitle"
                          class="routine-card-popin__productTitle"
                          v-titleSup=" list.RoutineProductTitle"
                        >
                        </h3>
                        <div
                          v-if="list.RoutineProductDescription"
                          class="routine-card-popin__productDesc"
                          v-titleSup="list.RoutineProductDescription"
                        > 
                        </div>
                        <div class="routine-card-popin__productCta">
                          <a
                            v-if="list.RoutineProductCTALabel"
                            :href="list.RoutineProductCTALink?.Href"
                            :target="list.RoutineProductCTALink?.Target"
                            @click="taggingpopinBuynow(list)"
                            >{{ list.RoutineProductCTALabel }}</a
                          >
                        </div>
                        <div
                          v-if="list.RoutineDisclaimer"
                          v-titleSup=" list.RoutineDisclaimer"
                          class="routine-card-popin__productNote"
                        > 
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="routine-card__infoContainer">
                  <div class="routine-card__title">
                    <h3 class="card-title" v-titleSup="item.CardTitle">
                    </h3>
                    <a
                      :href="item.CardCTALink?.Href"
                      :target="item.CardCTALink?.Target"
                      class="card-redirection"
                      @click="taggingBuynow(item)"
                      v-if="item.CardCTALabel"
                      >{{ item.CardCTALabel }}</a
                    >
                  </div>
                  <div class="routine-card__img">
                    <img
                    v-if="item.RoutineCollectionImage?.Src"
                      class="lazy"
                      src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                      :alt="
                        item.RoutineCollectionImage.Alt
                          ? item.RoutineCollectionImage.Alt
                          : ''
                      "
                      :data-src="
                        item.RoutineCollectionImage.Src
                          ? item.RoutineCollectionImage.Src
                          : ''
                      "
                    />
                  </div>
                </div>
              </div>
            </div>

            <button
              type="button"
              class="slider-control slider-control__next"
              data-slider-control="next"
            >
              <svg role="img" class="icon" aria-label="Next">
                <use
                  xlink:href="#arrow-right"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                ></use>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="routine-slider__note" v-if="sliderData.Disclaimer" v-titleSup="sliderData.Disclaimer "> 
    </div>
  </div>
</template>
<script>
export default {
  name: 'routine-slider',
  data() {
    return {
      openproductPopin: null,
      blurImgEnable: false,
    };
  },
  props: {
    sliderData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openPopinCta(data, index) {
      this.openproductPopin = index;
      this.taggingDiscoverRoutineCta(data);
    },
    closePopinCta() {
      this.openproductPopin = null;
    },

    tagging(ctaLabel, linkUrl, data) {
      let taggingData = {
        event: 'uaevent',
        event_name: 'body_button_click',
        ecommerce: 'undefined',
        cta_name: ctaLabel.toLowerCase(),
        link_url:
          linkUrl === 'none'
            ? 'none'
            : window.location.origin + linkUrl.toLowerCase(),
        module_name: 'routine block',
        event_detail: data.DMIVariable.toLowerCase(),
      };
      window.dataLayer.push(taggingData);
    },
    taggingBuynow(data) {
      this.tagging(data.CardCTALabel, data.CardCTALink?.Href, data);
    },

    taggingpopinBuynow(data) {
      this.tagging(
        data.RoutineProductCTALabel,
        data.RoutineProductCTALink?.Href,
        data
      );
    },
    taggingDiscoverRoutineCta(data) {
      this.tagging(this.sliderData.CTALabel, 'none', data);
    },
  },
};
</script>
